// extracted by mini-css-extract-plugin
module.exports = {"LikeCounter":"LikeCounter_LikeCounter__dTr2E","BackgroundImage":"LikeCounter_BackgroundImage__Q71Rv","Count":"LikeCounter_Count__FX4VN"};